import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';

import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import ico_plus_green from '../assets/images/ico_plus_green.png';
import ico_view from '../assets/images/ico_view.png';
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import ReactDOM from "react-dom";
import TRACKING from "../Shared/DataTrackingPoints";
import {selectClass, selectSchool, selectTeacher, updateStudent, updateTeacher, userLogout} from "../TeachersComponent/actions";
import {connect} from "react-redux";
import Helpers from "../Shared/Helpers";

let addClassInstruction = null;
let addStudentInstruction = null;
let addStudentStorage = localStorage.getItem('addStudent');

const getValue = (opts, val) => opts.find(o => o.value === val);
let getChecked = (checkList, studentId) => {
    let student = checkList.find(o => o.studentId === studentId);
    if(student){
        return student.checked;
    }else{
        return null;
    }
}

class SchoolAdminComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teachers: [],
            teacherToEdit: {},
            addTeacher: false,
            editTeacher: false,
            classes: [],
            class: {},
            classStudents: [],
            student: {},
            clickedClassId:-1,
            clickedTeacherId:-1,
            modalDialog: false,
            responseContent:'',
            schoolOptions: '',
            schoolValue: ''
        };
        this.handleAddTeacher = this.handleAddTeacher.bind(this);
    }

    async componentDidMount() {

        Helpers.authorize(this);

        if(this.props.lastSchool){
            await this.handleSchoolChange(this.props.lastSchool);
            let lastTeacher = this.props.lastTeacher;
            let selectTeacher = this.handleTeacherItemClick;
            if(lastTeacher){
                setTimeout(async function () {
                    await selectTeacher(lastTeacher);
                }, 100);
                let lastClass = this.props.lastClass;
                let selectClass = this.handleClassItemClick;
                if(lastClass){
                    setTimeout(async function () {
                        selectClass(lastClass);
                    }, 100);
                    if(this.props.lastStudent){
                        this.handleStudentClick(this.props.lastStudent,this.props.lastClass.id)
                    }
                }
            }
        }
    }

    handleSchoolLoaded =  async (schools) =>{
        await this.setState({schoolOptions: schools});
    }

    handleSchoolChange = async (newValue) => {
        REST.listTeachersInSchool(newValue).then(async (response) => {
            if (response.success) {
                this.setTeachers(response.body);
                await this.setState({
                    classes: [],
                    classStudents:[],
                    addTeacher: false,
                    editTeacher: false
                });
            }
            else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    };

    setTeachers = (object) => {
        this.setState({ teachers: object });
    }

    handleAddTeacher(event) {
        this.setState({ addTeacher: !this.state.addTeacher, editTeacher: false });
    }

    handleCancel = () => {
        this.setState({ addTeacher: false, editTeacher: false });
    }

     handleTeacherEditClick = (object) => {
        this.setState({ addTeacher: false, editTeacher: true, teacherToEdit: null });
        this.handleAddTeacher();
        this.setState({ addTeacher: false, editTeacher: true, teacherToEdit: object });
    }

    handleTeacherItemClick = async (object) => {
        this.setState({
            addTeacher: false,
            editTeacher: false,
            clickedTeacherId:object.id,
            classStudents: []
        });
        await this.listClasses(object.id);
        await this.props.updateTeacher(object);
        await this.props.selectTeacher(object);
    }

    listClasses(teacherId) {
        REST.teacherClassList(teacherId).then((response) => {
            if (response.success) {
                this.setState({ classes: response.body });
                console.log(response.body);
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    handleClassItemClick = (object) => {
        this.handleCancel();
        REST.listStudents(object.id).then(async (response) => {
            if (response.success) {
                let res = response.body;
                await this.setState({ classStudents: res, class: object, clickedClassId:object.id });
                await this.props.selectClass(object);
            } else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    };

    handleStudentClick = (student, classId) => {
        this.props.handleStudentClick(student, classId);
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    handleLogout = () => {
        REST.logout().then((response) => {
            if(localStorage.getItem('addClass') === 'hide'){
                addClassInstruction = localStorage.getItem('addClass');
            }
            if(localStorage.getItem('addStudent') === 'hide'){
                addStudentInstruction = localStorage.getItem('addStudent');
            }
            localStorage.removeItem('token');
            if(addClassInstruction !== null){
                localStorage.setItem('addClass',addClassInstruction);
            }
            if(addStudentInstruction !== null){
                localStorage.setItem('addStudent',addStudentInstruction);
            }
            this.props.history.push("/login");
        }, (error) => {
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        });
    }

    teacherAdded = () => {
        window.location.reload();
    }

    render() {
        return (
            <div>
                <HeaderComponent schoolAdmin={this.props.schoolAdmin} changeSchool={this.handleSchoolChange} schoolLoaded={this.handleSchoolLoaded} logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className={"row"}>
                                <div className={"col-md-10"}>
                                    <h1 className="fl">Teachers</h1>
                                </div>
                                <div className={"col-md-2"}>
                                    <a className="fr">
                                        <img src={ico_plus_green} onClick={this.handleAddTeacher} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                                    </a>
                                </div>
                                </div>
                                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable" style={{maxHeight:450, height:450}}>
                                    <TeachersListComponent
                                        teachers={this.state.teachers}
                                        handleItemClick={this.handleTeacherItemClick}
                                        handleEditClick={this.handleTeacherEditClick}
                                        clickedTeacherID={this.state.clickedTeacherId}
                                    />
                                </div>
                            </div>
                            {this.state.classes.length>0 && !this.state.editTeacher && !this.state.addTeacher?
                            <div className="col-md-3">
                                <div className={"col-md-10"}>
                                    <h1 className="fl">Classes</h1>
                                </div>
                                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable" style={{maxHeight:450, height:450}}>
                                    <ClassListComponent
                                        classes={this.state.classes}
                                        handleItemClick={this.handleClassItemClick}
                                        clickedClassID={this.state.clickedClassId}
                                    />
                                </div>
                            </div>:null}
                            {this.state.classStudents.length>0 && !this.state.editTeacher && !this.state.addTeacher?
                            <div className="col-md-6">
                                <ClassNavigation
                                    class={this.state.class}
                                    students={this.state.classStudents}
                                    handleAddStudent={this.handleAddStudent}
                                    studentClick={this.handleStudentClick}
                                    updateClassCallback={this.handleUpdateClass}
                                    deleteStudent={this.handleDeleteStudent}
                                />
                            </div>:null}
                            {this.state.addTeacher ?
                                <div className="col-md-9 container navbar-container">
                                    <AddTeacherComponent handleTeacherAdded={this.teacherAdded} schoolOptions = {this.state.schoolOptions} schoolValue = {this.props.lastSchool} handleCancel={this.handleCancel} />
                                </div> : null}
                            {this.state.editTeacher ?
                                <div className="col-md-9 container navbar-container">
                                    <UpdateTeacherComponent handleTeacherUpdated={this.teacherAdded} teacher={this.state.teacherToEdit} schoolOptions = {this.state.schoolOptions} schoolValue = {this.props.lastSchool} handleCancel={this.handleCancel} />
                                </div> : null}
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}

class AddTeacherComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstname: '',
            lastname: '',
            email: '',
            schoolId: this.props.schoolValue,
            inProject: true,
            modalDialog:false,
            responseContent:'' };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleName(event) {
        this.setState({ firstname: event.target.value });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
    }

    handleSave(event) {
        REST.createTeacher(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'The teacher account has been added successfully.\n' +
                        'Some school districts block emails from external sites which may prevent the teacher from receiving the user number and password link. If this is the case, you  may need to contact the school district to ask about blocked email.'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel(); this.props.handleTeacherAdded();},3500);
                this.myFormRef.reset();
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddTeacher" ref={(el) => this.myFormRef = el}>
                    <label htmlFor="inputTeacherName">First Name</label>
                    <input type="text" onChange={this.handleName} id="inputTeacherName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Last Name</label>
                    <input type="text" onChange={this.handleLastName} id="inputTeacherLastName" className="form-control" placeholder="Last Name" required />
                    <label htmlFor="inputTeacherEmail">Email</label>
                    <input type="text" onChange={this.handleEmail} id="inputTeacherEmail" className="form-control" placeholder="Email" required />
                    <label htmlFor="inputTeacherEmail">School</label>
                    <div style={{width:'68%'}}>
                        <Select
                            id={"addTeacherSchool"}
                            onChange={(newValue)=>{this.setState({ schoolId: newValue.value})}}
                            options={this.props.schoolOptions}
                            placeholder = {"Select a school..."}
                            value={getValue(this.props.schoolOptions, this.props.schoolValue)}

                        />
                    </div>
                </form>
                <div className="nav navbar fr" style={{marginTop:30}}>
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class UpdateTeacherComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstname: this.props.teacher.user.firstname,
            lastname: this.props.teacher.user.lastname,
            email: this.props.teacher.user.email,
            inProject: true,
            userId: this.props.teacher.userId,
            researcher: this.props.teacher.researcher,
            schoolId: this.props.schoolValue,
            modalDialog:false,
            modalDialogDelete:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleUserId = this.handleUserId.bind(this);
        this.handleReseacher = this.handleReseacher.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteTeacher = this.deleteTeacher.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.teacher.userId !== newProps.teacher.userId){
            this.setState({
                firstname: this.props.teacher.user.firstname,
                lastname: this.props.teacher.user.lastname,
                email: this.props.teacher.user.email,
                schoolId: this.props.schoolValue,
                userId: this.props.teacher.userId,
                researcher: this.props.teacher.researcher,
                modalDialog:false,
                modalDialogDelete:false });
        }
    }

    deleteTeacher = (confirm) =>{
        if(confirm) {
            this.handleDelete();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleName(event) {
        this.setState({ firstname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleUserId(event) {
        this.setState({ userId: event.target.value });
        event.preventDefault();
    }

    handleReseacher(event) {
        this.setState({ researcher: !this.state.researcher });
        // event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
        event.preventDefault();
    }

    handleSave(event) {
        REST.updateTeacher(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Data Successfully Updated!'
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
                this.props.handleTeacherUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
        event.preventDefault();
    }

    handleDelete(event) {
        REST.deleteTeacher(this.state.userId).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Successfully Deleted!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();this.props.handleTeacherUpdated();},3500);
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <DeleteDialogBox
                    confirmDelete={this.deleteTeacher}
                    modalOpen={this.state.modalDialogDelete}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form>
                    <label htmlFor="inputTeacherName">First Name</label>
                    <input type="text" value={this.state.firstname} onChange={this.handleName} id="inputTeacherName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Last Name</label>
                    <input type="text" value={this.state.lastname} onChange={this.handleLastName} id="inputTeacherLastName" className="form-control" placeholder="Last Name" required />
                    {/*<label htmlFor="inputTeacherEmail">Email</label>*/}
                    {/*<input type="text" onChange={this.handleEmail} id="inputTeacherEmail" value={this.state.email} className="form-control" placeholder="Email" required />*/}
                    <label htmlFor="inputTeacherUserId">User Number</label>
                    <input type="text" value={this.state.userId} onChange={this.handleUserId} id="inputTeacherUserId" className="form-control" placeholder="UserID" required />
                    <div style={{width:'68%'}}>
                        <Select
                            id={"updateTeacherSchool"}
                            onChange={(newValue)=>{this.setState({ schoolId: newValue.value})}}
                            options={this.props.schoolOptions}
                            placeholder = {"Select a school..."}
                            value={getValue(this.props.schoolOptions, this.state.schoolId)}
                        />
                    </div>
                    <label style={{width:'30%'}}> </label>
                    <div style={{display:'inline-block', position:'relative', width:'70%'}}>
                    <label htmlFor="cbResearcher" className="cb "><input type="checkbox" onChange={this.handleReseacher} name="researcher" checked={this.state.researcher} id="cbResearcher" /><span className="checkmark"></span> Researcher</label>
                    </div><br />
                </form>
                <div className="nav navbar fl">
                    <a onClick={(event)=>{this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TEACHER?'});   event.stopPropagation();}} className="handBtn">
                        <span>Delete Teacher</span>
                    </a>
                </div>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class TeachersListComponent extends Component {
    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    }

    handleEditClick = (object) => {
        this.props.handleEditClick(object);
    }

    render() {
        let items = this.props.teachers;
        const teachers = items.map((item) => {
            if (item.user) {
                return <TeachersListItemComponent key={item.id} item={item} active={this.props.clickedTeacherID===item.id ? "active":""} handleClick={this.handleItemClick} handleEditClick={this.handleEditClick}/>
            }
            else return null;
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                    {teachers}
                </tbody>
            </table>
        );
    }
}

class TeachersListItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    handleEditClick(event) {
        this.props.handleEditClick(this.props.item);
        event.preventDefault();
    }

    render() {
        return (
            <tr className={"clickable-row "+this.props.active}>
                <td onClick={this.handleClick} >{this.props.item.user.lastname}, {this.props.item.user.firstname}  </td>
                <td className="fitWidth">
                    <a>
                        <img onClick={this.handleEditClick} src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        );
    }
}

class ClassListComponent extends Component {

    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    };

    render() {
        let items = this.props.classes;
        const classes = items.map((item) => {
            return <ClassItemComponent key={item.id} item={item} active={this.props.clickedClassID===item.id ? "active":""} handleClick={this.handleItemClick} deleteClass={this.props.deleteClass}/>
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                {classes}
                </tbody>
            </table>
        );
    }
}

class ClassItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.deleteClass = this.deleteClass.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    deleteClass(event){
        let confirmed = window.confirm("Are you sure that you want to delete this class ?");
        if(confirmed) {
            this.props.deleteClass(this.props.item);
        }
        event.stopPropagation();
    }

    render() {
        return (
            <tr className={"clickable-row "+this.props.active} onClick={this.handleClick}>
                <td>{this.props.item.name}</td>
            </tr>
        );
    }
}

class ClassNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            class: this.props.class,
            listStudents: true,
            listMultipleStudents: false
        };
        this.handleStudentsTab = this.handleStudentsTab.bind(this);
        this.handleMultipleStudentsTab = this.handleMultipleStudentsTab.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.students !== newProps.students){
            this.setState({
                listStudents: true,
                listMultipleStudents: false
            });
        }
    }

    handleStudentClick = (student, classId) => {
        this.props.studentClick(student, classId);
    }

    handleAddStudent = () => {
        this.props.handleAddStudent(this.state.class.id);
    }

    handleStudentsTab(event) {
        this.setState({ listStudents: true, listMultipleStudents: false });
        event.preventDefault();
    }

    handleMultipleStudentsTab(event) {
        this.setState({ listStudents: false, listMultipleStudents: true});
        event.preventDefault();
    }

    handleClassTab(event) {
        this.setState({ listStudents: false, listMultipleStudents: false});
        // event.preventDefault();
    }

    handleCancel = () => {
        this.setState({ listStudents: true, listMultipleStudents: false });
    }

    handleUpdateClass = (object) => {
        this.props.updateClassCallback(object);
    }

    listStudents() {
        REST.listStudents(this.props.class.id).then((response) => {
            if (response.success) {
                this.setState({ students: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('List students error', error);
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-md-12">
                {this.state.listStudents ?
                    (
                        <StudentsList
                            handleClassTab={this.handleClassTab}
                            handleMultipleStudentsTab={this.handleMultipleStudentsTab}
                            classId={this.state.class.id}
                            handleAddStudent={this.handleAddStudent}
                            students={this.props.students}
                            handleItemClick={this.handleStudentClick}
                            deleteStudent={this.props.deleteStudent}
                        />
                    ) :this.state.listMultipleStudents? (
                        <MultipleStudents
                            handleStudentsTab = {this.handleStudentsTab}
                            handleClassTab={this.handleClassTab}
                            classId={this.state.class.id}
                            handleAddStudent={this.handleAddStudent}
                            students={this.props.students}
                            handleItemClick={this.handleStudentClick}
                            deleteStudent={this.props.deleteStudent}
                        />
                    ):
                    (
                        <div>
                            <ul className="nav nav-tabs">
                                <li onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                                <li className="active" onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                            </ul>
                        </div>
                    )
                }
            </div>
        );
    }
}


class StudentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAddStudentHint:true,
            analytics: {
                type: null,
                metadata: null,
            }}
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
        this.handleAddStudent = this.handleAddStudent.bind(this);
        this.handleAddStudentHint = this.handleAddStudentHint.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }
    componentDidMount(){
        if(localStorage.getItem('addStudent') === 'hide'){
            this.setState({showAddStudentHint: false})
        }
    }
    handleAddStudentHint(){
        this.setState({showAddStudentHint: !this.state.showAddStudentHint})
    }
    getTarget() {
        return ReactDOM.findDOMNode(this.target);
    }

    handleClassTab(event) {
        this.props.handleClassTab();
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleItemClick = async (student) => {
        await this.setState({
                analytics:{
                    type:TRACKING.TEACHER_STUDENT_DETAILS_VIEW,
                    metadata:{userId: student.userId}
                }
            },
            () => {this.handleAnalytics();this.props.handleItemClick(student, this.props.classId);}  );
    };

    handleAddStudent(event) {
        this.props.handleAddStudent();
        this.handleAddStudentHint();
        localStorage.setItem('addStudent', 'hide');
        event.preventDefault();
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddStudentHint
        };
        let items = this.props.students;
        let students = items.map((student) => {
            return <StudentListItem key={student.id} student={student} handleClick={this.handleItemClick} deleteStudent={this.props.deleteStudent}/>
        });
        return (
            <div>
                <ul className="nav nav-tabs">
                    <li className="active" onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                    <li onClick={this.props.handleMultipleStudentsTab}><a data-toggle="tab">Share/Transfer Students</a></li>
                </ul>
                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable" style={{maxHeight:450, height:450}}>
                    <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                        <thead>
                        <tr className="clickable-row">
                            <th>Full Name</th>
                            <th className="fitWidth">User Number</th>
                            <th className="fitWidth">Password</th>
                        </tr>
                        </thead>
                        <tbody>
                        {students}
                        </tbody>
                    </table>
                </div>
            </div >
        );
    }
}

class StudentListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {modalDialog:false, responseContent:''}
        this.handleClick = this.handleClick.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.student);
        event.stopPropagation();
    }

    deleteStudent = (confirm) => {
        if(confirm) {
            this.props.deleteStudent(this.props.student);
        }
    }

    render() {
        let student = this.props.student;
        return (
            <tr className="clickable-row">
                <DialogBox
                    modalOpen={this.state.modalDialog}
                    confirmDelete={this.deleteStudent}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}}
                />
                <td onClick={this.handleClick}>{student.user.firstname} {student.user.lastname}</td>
                <td onClick={this.handleClick}>{student.userId}</td>
                <td onClick={this.handleClick}>{student.user.password}</td>
            </tr>
        )
    }
}

class MultipleStudentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAddStudentHint:true,
            showTeacherInfo: false,
            showClassList: false,
            allChecked: false,
            checkList: [],
            studentIds: [],
            students: this.props.students,
            analytics: {
                type: null,
                metadata: null,
            }};
        this.sortStudentsByName = this.sortStudentsByName.bind(this);
        this.sortStudentsByUserId = this.sortStudentsByUserId.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.handleAllChecked = this.handleAllChecked.bind(this);
        this.handleCancelTransfer = this.handleCancelTransfer.bind(this);
    }
    componentDidMount(){
        let students = this.props.students;
        let checkList = [];
        students.forEach((student) => {
            checkList.push ({studentId: student.id, checked: false});
        });
        this.setState({checkList:checkList});
    }

    handleClassTab(event) {
        this.props.handleClassTab();
    }

    sortStudentsByUserId(){
        this.setState ({
            students: this.state.students.sort((a,b) =>
                ((a.userId > b.userId) ? 1 : ((a.userId < b.userId) ? -1 : 0))
            )
        });
    }

    sortStudentsByName(){
        this.setState ({
            students: this.state.students.sort((a,b) =>{
                let nameA = a.user.firstname + ' ' + a.user.lastname;
                let nameB = b.user.firstname + ' ' + b.user.lastname;
                return  ((nameA > nameB) ? 1 : ((nameA < nameB) ? -1 : 0));

            })
        });

    }

    handleSelect = async (studentId, isChecked) => {
        let checkList = this.state.checkList;
        for(let i=0; i<checkList.length; i++){
            if(checkList[i].studentId == studentId){
                checkList[i].checked = isChecked;
            }
        }
        let studentIds = [];
        for(let i=0; i<checkList.length; i++){
            if(checkList[i].checked){
                studentIds.push(checkList[i].studentId);
            }
        }
        this.setState({checkList:checkList, studentIds:studentIds});
    };

    handleContinue(){
        this.setState({
            showTeacherInfo:true
        })
    }

    handleAllChecked(){
        let newCheckStatus = !this.state.allChecked;
        let students = this.state.students;
        let checkList = [];
        students.forEach((student) => {
            if (newCheckStatus) {
                checkList.push({studentId: student.id, checked: true});
            }else{
                checkList.push({studentId: student.id, checked: false});
            }
        });

        let studentIds = [];
        for(let i=0; i<checkList.length; i++){
            if(checkList[i].checked){
                studentIds.push(checkList[i].studentId);
            }
        }

        this.setState({
            studentIds: studentIds,
            checkList: checkList,
            allChecked: newCheckStatus
        })
    }

    handleCancelTransfer(){
        this.setState({
            showTeacherInfo: false
        });
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddStudentHint
        };
        let items = this.state.students;
        let students = items.map((student) => {
            return <MultipleStudentListItem key={student.id} student={student} checked={getChecked(this.state.checkList, student.id)} handleSelect={this.handleSelect} />
        });
        return (
            <div>
                <ul className="nav nav-tabs">
                    <li onClick={this.props.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                    <li className="active" onClick={this.handleMultipleStudentsTab}><a data-toggle="tab">Share/Transfer Students</a></li>
                </ul>
                <div className="tab-pane active solidBorder noPadding">
                    <p>You can share or transfer students to another teacher.</p>
                    <p>Step 1: Select the students to share or transfer</p>
                    <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                        <thead>
                        <tr className="clickable-row">
                            <th className="fitWidth">
                                <input type="checkbox" onChange={this.handleAllChecked} name="selectStudent" checked={this.state.allChecked} id="allChecked" />
                            </th>
                            <th><a onClick={this.sortStudentsByName}>Full Name</a></th>
                            <th className="fitWidth"><a onClick={this.sortStudentsByUserId}>User Number</a></th>
                        </tr>
                        </thead>
                        <tbody>
                        {students}
                        </tbody>
                    </table>
                </div>
                <div className="divBottomRelative tr">
                    <a onClick={this.handleContinue} className="handBtn">
                        <span>Continue</span>
                    </a>
                </div>
                {this.state.showTeacherInfo?<div>
                    <TransferStudentComponent schoolAdmin={this.props.schoolAdmin} studentIds={this.state.studentIds} handleCancelTransfer={this.handleCancelTransfer} />
                </div>:null
                }
            </div >
        );
    }
}
const MultipleStudents = withRouter(MultipleStudentsList);

class MultipleStudentListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSelected: this.props.checked
        }
        this.handleSelectStudent = this.handleSelectStudent.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.checked !== newProps.checked){
            this.setState({ isSelected: newProps.checked});
        }
    }

    handleSelectStudent = async (studentId) => {
        await this.setState({
            isSelected: !this.state.isSelected
        });
        this.props.handleSelect(studentId,this.state.isSelected);

    }

    render() {
        let student = this.props.student;
        return (
            <tr className="clickable-row">
                <td>
                    <input type="checkbox" onChange={()=>this.handleSelectStudent(student.id)} name="selectStudent" checked={this.state.isSelected} id="checkSelected" />
                </td>
                <td onClick={()=>this.handleSelectStudent(student.id)} >{student.user.firstname} {student.user.lastname}</td>
                <td onClick={()=>this.handleSelectStudent(student.id)}>{student.userId}</td>
            </tr>
        )
    }
}

const TransferStudentComponent = withRouter(class TransferStudentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teacherId: 0,
            classId: 0,
            studentId: this.props.studentId,
            studentIds: this.props.studentIds,
            classes: [],
            share: false,
            modalDialog:false,
            responseContent: ''
        };
        this.handleDone = this.handleDone.bind(this);
        this.handleCancelTransfer = this.handleCancelTransfer.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.studentIds !== newProps.studentIds){
            this.setState({ studentIds: newProps.studentIds});
        }
    }

    handleBackClick = () => {
        if(this.props.schoolAdmin){
            this.props.history.push("/school-admin");
        }else {
            this.props.history.push("/teacher");
        }
    }

    handleCorrectTeacherData = (data) => {
        this.setState({ teacherId: data.teacher.id, classes: data.teacher.classes });
    };

    handleCancelTransfer = () => {
        this.props.handleCancelTransfer();
    };

    handleClassSelect = (classId) => {
        this.setState({ classId: parseInt(classId) });
    };

    async handleDone(event,share) {
        let promptText;
        if(share){
            promptText = 'Are you sure you wish to share the students?';
        }else{
            promptText = 'Are you sure you wish to transfer the students?';
        }
        if (window.confirm(promptText)) {
            await this.setState({share:share});
            REST.transferMultipleStudents(this.state).then((response) => {
                this.setState({
                    modalDialog: true,
                    responseContent: this.state.share?'Student has been shared Successfully!':'Student has been transferred Successfully!'
                });
            }, (error) => {
                console.log(`transfer student error`, error);
            });
        }
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active}); window.location.reload()}} />
                <TeacherInfoTransferComponent correctTeacherData={this.handleCorrectTeacherData} handleCancelTransfer={this.handleCancelTransfer} />
                {this.state.classes && this.state.classes.length > 0 ?
                    <div>
                        <TeacherClassTransferComponent classes={this.state.classes} handleClassSelect={this.handleClassSelect} />
                        <div className="clearfix"></div>
                        <div className="divBottomRelative">
                            <hr />
                            <a onClick={this.handleCancelTransfer} className="handBtn">
                                <span>Cancel</span>
                            </a>
                            <a onClick={(e)=>this.handleDone(e,false)} disabled={this.state.classId === 0} className="handBtn">
                                <span>Transfer</span>
                            </a>
                            <a onClick={(e)=>this.handleDone(e,true)} disabled={this.state.classId === 0} className="handBtn">
                                <span>Share</span>
                            </a>
                        </div>
                    </div> :null
                }
            </div>
        )
    }
});

class TeacherInfoTransferComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { firstName: '', lastName: '', teacherId: '', hideButtons: false, modalDialog:false, responseContent:'' };
        this.handleFirstName = this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleLoginID = this.handleLoginID.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    handleFirstName(event) {
        this.setState({ firstName: event.target.value.replace(/\s+/g, '') });
    }

    handleLastName(event) {
        this.setState({ lastName: event.target.value.replace(/\s+/g, '') });
    }

    handleLoginID(event) {
        event.target.value = event.target.value.replace(/[^0-9.]+/g, '');
        this.setState({ teacherId: event.target.value });
    }

    validate(){
        let valid = true;
        if (this.state.firstName.length === 0) {
            valid = false;
            document.getElementById("inputTeacherName").classList.add('validationRed');

        } else {
            document.getElementById("inputTeacherName").classList.remove('validationRed');
        }
        if (this.state.lastName.length === 0) {
            valid = false;
            document.getElementById("inputTeacherLastName").classList.add('validationRed');
        } else {
            document.getElementById("inputTeacherLastName").classList.remove('validationRed');
        }
        if (this.state.teacherId.length === 0 || this.state.teacherId === null) {
            valid = false;
            document.getElementById("inputTeacherLoginID").classList.add('validationRed');
        }
        else {
            document.getElementById("inputTeacherLoginID").classList.remove('validationRed');
        }
        return valid;

    }

    handleContinue(event) {
        if (this.validate()) {
            document.getElementById("validWarning").classList.add("hidden");
            this.listExternalTeacher();
        }
        else {
            document.getElementById("validWarning").classList.remove("hidden");
        }
    }

    listExternalTeacher() {
        REST.listExternalTeacher(this.state).then((response) => {
            if (response.success && response.body) {
                this.props.correctTeacherData(response.body);
                this.setState({ hideButtons: true });
            } else if (response.success){
                this.setState({
                    modalDialog: true,
                    responseContent:'This teacher doesn\'t have any classes.'
                });
            }else{
                this.setState({
                    modalDialog: true,
                    responseContent:'Incorrect input! Check it and retry!'
                });
            }

        }, (error) => {
            console.log('Error', error);
        });
    }

    handleCancel(event) {
        this.props.handleCancelTransfer();
    }

    render() {
        return (
            <div>
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <p>Step 2: Share/ transfer students with a teacher</p>
                <p>Enter the new teacher's first name, last name and user number for AvePM. Then you will be asked to select the new class name for the students.
                </p>
                <form>
                    <div id={"validWarning"} className={"hidden"} style={{color:'red',paddingBottom:10}}> Fields with red outline have to be filled in or selected!</div>
                    <label htmlFor="inputTeacherName">Teacher First Name</label>
                    <input type="text" onChange={this.handleFirstName} id="inputTeacherName" className="form-control " placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Teacher Last Name</label>
                    <input type="text" onChange={this.handleLastName} id="inputTeacherLastName" className="form-control " placeholder="Last Name" required />
                    <label htmlFor="inputTeacherLoginID">Teacher User Number</label>
                    <input type="text" onInput={this.handleLoginID} id="inputTeacherLoginID" className="form-control " placeholder="User Number" required />
                </form>
                <div className="clearfix"></div>
                {this.state.hideButtons ? null :
                    <div className="divBottomRelative">
                        <hr />
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleContinue} className="handBtn">
                            <span>Continue</span>
                        </a>
                    </div>
                }
            </div>
        )
    }
}

class TeacherClassTransferComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { classes: this.props.classes || [] };
        this.handleClassSelect = this.handleClassSelect.bind(this);
    }

    handleClassSelect(event) {
        this.props.handleClassSelect(event.value);
    }

    render() {
        let options = [];
        options[0] = <option key={0} value={0}>Select a class</option>
        for (var i = 0; i < this.state.classes.length; i++) {
            let c = this.state.classes[i];
            // options[i + 1] = <option key={c.id} value={c.id}>{c.name}</option>;
            options.push({ value: c.id, label: c.name});
        }
        return (
            <div>
                <p style={{marginTop:5}}>Step 3: In the drop down list, select a class into which the student will be placed.</p>
                <Select onChange={this.handleClassSelect} id="classes" name="classes"   options={options} isSearchable={false} />
            </div>
        )
    }
}

const bindActionToProps = dispatch => {
    return {
        selectSchool: async(selectedSchool) => await dispatch(selectSchool(selectedSchool)),
        selectTeacher: async(selectedTeacher) => await dispatch(selectTeacher(selectedTeacher)),
        selectClass: async(selectedClass) => await dispatch(selectClass(selectedClass)),
        updateStudent: async(selectedStudent) => await dispatch(updateStudent(selectedStudent)),
        updateTeacher: async(data) => await dispatch(updateTeacher(data)),
        userLogout: async() => await dispatch(userLogout())
    };
};


const mapStateToProps = state => ({
    lastSchool: state.teacherReducer.lastSchool,
    lastTeacher: state.teacherReducer.lastTeacher,
    lastClass: state.teacherReducer.lastClass,
    lastStudent: state.teacherReducer.student,
    teacher: state.teacherReducer.teacher,
    schoolAdmin: state.teacherReducer.schoolAdmin
});


export default connect(mapStateToProps,bindActionToProps)(withRouter(SchoolAdminComponent));


// WEBPACK FOOTER //
// ./src/AdminComponent/SchoolAdmin.js